import DownloadManager from './DownloadManager'
export default DownloadManager
